import { render, staticRenderFns } from "./inputBtn.pug?vue&type=template&id=11f024f2&lang=pug&external"
import script from "./inputBtn.js?vue&type=script&lang=js&external"
export * from "./inputBtn.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f024f2')) {
      api.createRecord('11f024f2', component.options)
    } else {
      api.reload('11f024f2', component.options)
    }
    module.hot.accept("./inputBtn.pug?vue&type=template&id=11f024f2&lang=pug&external", function () {
      api.rerender('11f024f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/btn/index.vue"
export default component.exports